<template>
  <div class="warp-visi-misi bg-neutral-50 my-[2vw] px-4 md:px-[15vw]">
    <div class="container mx-auto py-4 text-left">
      <TitleSection :title="activeProdi?.title || 'Memuat...'" />

      <!-- Loader -->
      <div v-if="visiMisiStore.loading" class="text-center py-10 text-gray-500">
        Memuat data...
      </div>

      <!-- Konten -->
      <template v-else>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 my-[5vh]">
          <!-- Tabs -->
          <div class="flex flex-col items-center justify-center">
            <div class="card-btn text-center md:py-[5vw]">
              <div
                v-for="menu in menus"
                :key="menu"
                class="menus"
                :class="{ active: activeTab === menu.toLowerCase() }"
                @click="activeTab = menu.toLowerCase()"
              >
                {{ menu.toUpperCase() }}
              </div>
            </div>
          </div>

          <!-- Deskripsi -->
          <div class="md:col-span-2 flex items-center">
            <transition name="fade" mode="out-in">
              <div
                :key="activeTab"
                class="description h-full w-full bg-white max-h-[30vh] md:max-h-[30vh] overflow-y-auto rounded-[5px]  p-4"
              >
                <div
                  v-html="activeProdi?.[activeTab] || '<em>Belum ada isi</em>'"
                  class="text-gray-700 text-sm leading-relaxed"
                ></div>
              </div>
            </transition>
          </div>
        </div>

        <!-- Card Prodi -->
        <div class="grid grid-cols-3 md:grid-cols-3  md:gap-4 mt-10">
          <div
            v-for="item in visiMisiStore.data.filter((item) => item.id !== 1)"
            :key="item.id"
            class="card-prodi w-full h-12 md:h-16 col-span-3 md:col-span-1 relative flex items-center justify-center cursor-pointer"
            @click="setActiveProdi(item)"
          >
            <div
              class="w-full h-0 left-0 md:top-[32px] absolute outline outline-1 outline-offset-[-0.50px] outline-amber-400"
            ></div>
            <div
              class="min-w-[95%] h-10 md:w-96 md:h-16 absolute bg-white z-2 rounded-2xl border text-center px-4"
                :class="{
                'border-amber-400': activeProdi?.id !== item.id,
                'border-emerald-700 bg-emerald-700 text-amber-400': activeProdi?.id === item.id
                }"
              
            >
              <div
                class="w-full h-full flex items-center  justify-center text-sm md:text-xl font-medium"
              >
                {{ item.prodi }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useVisiMisiStore } from "@/store/visiMisiStore"; // Path diperbaiki
import TitleSection from "@/components/TitleSection.vue";

const visiMisiStore = useVisiMisiStore();
const activeTab = ref("visi");
const activeProdi = ref(null);

const menus = ["Visi", "Misi", "Tujuan"];

const setActiveProdi = (item) => {
  activeProdi.value = item;
  activeTab.value = "visi";
};

onMounted(async () => {
  await visiMisiStore.fetchDummyData();
  if (visiMisiStore.data.length) {
    activeProdi.value = visiMisiStore.data[0];
  }
});
</script>

<style scoped lang="scss">
.warp-visi-misi {
  .card-btn {
    .menus {
      font-size: 1.25rem;
      font-weight: bold;
      color: #014a3d;
      cursor: pointer;
      transition: color 0.3s, border-bottom 0.3s;
      margin-bottom: 0.5rem;
    }

    .menus:hover {
      color: #fdcb2c !important; /* Menambahkan !important untuk memastikan hover diterapkan */
    }

    .menus.active {
      color: #fdcb2c !important; /* Menambahkan !important untuk memastikan active diterapkan */
      border-bottom: 2px solid #fdcb2c;
    }
  }

  .card-prodi {
    transition: transform 0.2s ease-in-out;
    &:hover {
      transform: scale(1.02);
    }
  }

  .description {
    min-height: 150px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
